import { define } from 'wicked-elements'

define('[data-component~="nav-smooth"]', {
  init() {
    this.$navLinks = this.element.querySelectorAll('.nav-link')
    this.$homeLink = document.querySelector('.home-link')
    this.handleNavClick = this.handleNavClick.bind(this)
    this.handleHomeClick = this.handleHomeClick.bind(this)
    this.$navLinks.forEach(link => {
      link.addEventListener('click', this.handleNavClick)
    })
    this.$homeLink.addEventListener('click', this.handleHomeClick)
  },
  disconnected() {
    this.$navLinks.forEach(link => {
      link.removeEventListener('click', this.handleNavClick)
    })
    this.$homeLink.removeEventListener('click', this.handleHomeClick)
  },
  handleNavClick(e) {
    const href = e.currentTarget.getAttribute('href')
    if (href && href.startsWith('#')) {
      const target = document.getElementById(href.slice(1))
      if (target) {
        e.preventDefault()
        target.scrollIntoView({ behavior: 'smooth' })
        document.body.classList.remove('menu-open')
      }
    }
  },
  handleHomeClick(e) {
    if (window.location.pathname === '/') {
      e.preventDefault()
      window.scrollTo({ top: 0, behavior: 'smooth' })
      document.body.classList.remove('menu-open')
    }
  }
}) 